export default __webpack_public_path__ + "static/media/NewCastle-2022.542c8407.jpg";